import _ from 'lodash'

import { tours } from '../../api/api'
import { getDestinationMapFromTours } from '../../utilities/content/tours'
import { convertDestinationFilterIdsToTitles } from '../../utilities/filters/destinations'
import { filterTours } from '../../utilities/filters/filterTours'

import {
  fetchContent,
} from './fetchContent'

export const FETCH_TOURS_BEGIN   = 'FETCH_TOURS_BEGIN'
export const FETCH_TOURS_SUCCESS = 'FETCH_TOURS_SUCCESS'
export const FETCH_TOURS_ERROR = 'FETCH_TOURS_ERROR'

export const fetchTours = () => (dispatch, getState) => {
  dispatch({ type: FETCH_TOURS_BEGIN })
  const brand = _.get(getState(), 'configurationData.data.brand')
  return tours(brand)
    .then(response => {
      const destinationMap = getDestinationMapFromTours(response)
      const filterConfig = _.get(getState(), 'configurationData.data.filters', {})

      // drupal passes us destination ids in the filter config. the client requested that
      // any front end filtering only display destination titles and not ids in url query
      // params. as a result the filter logic was changed to filter by title (which the
      // client assures us is unique). we convert these ids to titles once ingested to
      // avoid additional changes on the drupal side and to maintain filtering consistency
      // in this app.
      const convertedFilterConfig = convertDestinationFilterIdsToTitles(filterConfig, destinationMap)
      const filteredTours = filterTours(response, convertedFilterConfig)

      // filter content is pulled from tour data to prevent
      // showing filter options with no results
      dispatch(fetchContent(filteredTours))

      dispatch({ type: FETCH_TOURS_SUCCESS, payload: filteredTours })
    })
    .catch(error => dispatch({ type: FETCH_TOURS_ERROR, payload: true }))
}
